import { render, staticRenderFns } from "./Synchro.vue?vue&type=template&id=248169a0&scoped=true&"
import script from "./Synchro.vue?vue&type=script&lang=js&"
export * from "./Synchro.vue?vue&type=script&lang=js&"
import style0 from "./Synchro.vue?vue&type=style&index=0&id=248169a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248169a0",
  null
  
)

export default component.exports